/* eslint-disable max-len */

const DUAL_PATH_CATEGORIES = {
  brio_inaisle_sfi_generalfs: 'DEFAULT_SERVICE',
  brio_inaisle_sfi_twht: 'TANKLESS_WATER_HEATER',
  brio_inaisle_sfi_whtr: 'TANK_WATER_HEATER',
  BRIO_INAISLE_SFI_FENC: 'FENCING',
  dualpath_inaisle_sfi_generators: 'GENERATORS',
  dualpath_inaisle_sfi_windows: 'WINDOWS',
  'door-installation-dp/893e44520': 'DOORS',
  'dreamline-door-installation/44fbb1b75': 'DREAMLINE_SHOWER_DOOR',
  'plumbing-repair-dp/9f2b4389b': 'PLUMBING_REPAIR',
  'water-heater-repair-dp/201c992c0': 'WATER_HEATER_REPAIR',
  'cleancut-tub-installation-dp/28b4e734e': 'CLEANCUT_TUBS',
  BRIO_INAISLE_SFI_CLOS_ORG: 'CLOSETS',
  'countertop-installation-dp/6228e49a9': 'COUNTER_TOPS',
  'mini-split-installation-dp/723194ce9': 'MINI_SPLITS',
  'garage-door-opener-installation': 'GARAGE_DOOR'
};

const dualPathTooltipCategories = {
  DEFAULT_SERVICE: [
    'Submit your contact information for a free pricing estimate and consultation',
    'Our expert installer will discuss the options available that best meet your needs and budget',
    'A licensed, local installer will schedule your installation and deliver the materials to your home',
    'Once the job is completed, we’ll clean up the area and request that you provide feedback on how we did'
  ],
  // Doors
  DOORS: [
    'Submit your contact information, and our project specialist will set up a professional measurement of your door opening',
    'A licensed, local installer will schedule and complete your measurement, and our project specialist will help select a door that meets your needs, budget and measurements',
    'Once your door arrives, our installer will schedule, deliver and complete the installation',
    'After the job is complete, we’ll clean up the area and request that you provide feedback on how we did'
  ],
  // tankless water heater
  TANKLESS_WATER_HEATER: [
    'Submit your contact information for a pricing estimate.',
    'Our authorized service provider will call to discuss your current setup and the best options for your needs and budget. They will also provide an estimate over the phone or schedule a free in-home consultation, if needed, to assess further.',
    'During your install and/or consultation, our local, licensed installer will bring the necessary water heater with them, survey the existing setup to ensure everything is up to code, and will provide you with a project quote before proceeding further.',
    'When you’re ready to move forward, the installer will immediately proceed with the installation or schedule an installation date that’s convenient for you.',
    'Once the install is complete, the installer will fill and test your new water heater, clean up the job site, and haul away your old water heater.',
    'The installer will also pull a permit, and schedule an inspection by the local municipality, but only where required.'
  ],
  // water heater
  TANK_WATER_HEATER: [
    'Submit your contact information for a pricing estimate.',
    'Our authorized service provider will call to discuss your current setup and the best options for your needs and budget. They will also provide an estimate over the phone or schedule a free in-home consultation, if needed, to assess further.',
    'During your install and/or consultation, our local, licensed installer will bring the necessary water heater with them, survey the existing setup to ensure everything is up to code, and will provide you with a project quote before proceeding further.',
    'When you’re ready to move forward, the installer will immediately proceed with the installation or schedule an installation date that’s convenient for you.',
    'Once the install is complete, the installer will fill and test your new water heater, clean up the job site, and haul away your old water heater.',
    'The installer will also pull a permit, and schedule an inspection by the local municipality, but only where required.'
  ],
  // fencing
  FENCING: [
    'Submit your contact information for a free pricing estimate and consultation',
    'Our local fencing installer will call to discuss your fencing needs and set up a free in-home consultation.',
    'During your free consultation, a licensed, local installer will measure your yard, review style options, and provide a project quote.',
    'When you’re ready to move forward, we’ll order the materials and schedule an installation and delivery date that’s convenient for you.',
    'After the installation is complete, the installer will haul away debris and clean the job site. They will also conduct a final inspection and review product and service warranties.'
  ],
  // generator
  GENERATORS: [
    'Submit your contact information for a free pricing estimate and consultation',
    'Our expert installer will discuss the options available that best meet your needs and budget and schedule your free in-home consultation.',
    'During your consultation, a licensed, local installer will review your home’s energy needs, make product recommendations, and review pricing and financing options.',
    'When you’re ready to move forward, the installer will order the material\'s and schedule an installation and delivery date that’s convenient for you.',
    'After the installation, the installer will clean the job site, make a final inspection, and review your product and service warranties.'
  ],
  WINDOWS: [
    'Submit your contact information for a free pricing estimate and consultation',
    'A Home Depot design consultant will call to discuss your current setup and the best options for your needs and budget. They will also set up a free in-home consultation',
    'During your consultation, we will help you choose the best windows for your needs, take professional measurements, and provide you with a project quote',
    'When you’re ready to move forward, we will order your windows and schedule your installation date',
    'After the installation is complete, we will haul away your old windows and clean up the job site',
    'Your new windows will come with a Home Depot Installation warranty and Manufacturers Product warranty'
  ],
  // dreamline door installtion
  DREAMLINE_SHOWER_DOOR: [
    'Submit your contact information for a free pricing estimate and consultation.',
    'Our local installer will call to discuss your needs and set up a free consultation.',
    'During your consultation, we’ll discuss your custom shower door project, make product recommendations, and review your pricing and financing options.',
    'When you’re ready to move forward, we’ll order all materials and set up an installation date that’s convenient for you.',
    'After the installation, we’ll clean the job site, make a final inspection, go over product and service warranties and request that you provide feedback on how we did.'
  ],
  // plumbing
  PLUMBING_REPAIR: [
    'Once you submit your contact info, one of our licensed, local, authorized plumbing service providers will contact you to discuss your project. They will also provide an estimate over the phone or schedule an in-home consultation to assess further.',
    'When you’re ready to move forward our plumber will schedule service when its most convenient for you.',
    'Once installation is complete, our plumber will test the repairs or installation, review the work with you, and clean up the job site.'
  ],
  // Garage-door opener installation
  GARAGE_DOOR: [
    'Enter your zip code to design and price your garage door',
    'Add installation and a garage door opener to complete the project',
    'After payment, our local installer will schedule a site inspection to confirm measurements',
    'When your garage door is ready, the installer will schedule your installation and deliver the materials to your home',
    'Once the job is completed, we’ll clean up the area and request that you provide feedback on how we did'
  ]
};

const headingCategory = {
  FENCING: 'Fence Installation',
  TANKLESS_WATER_HEATER: 'Water Heater Installation',
  TANK_WATER_HEATER: 'Water Heater Installation',
  GENERATORS: 'Generator Installation',
  WINDOWS: 'Window Installation',
  DREAMLINE_SHOWER_DOOR: 'Shower Door Installation',
  PLUMBING_REPAIR: 'Plumbing Repair',
  WATER_HEATER_REPAIR: 'Water Heater Repair',
  CLEANCUT_TUBS: 'CleanCut Tub Installation',
  DOORS: 'Door Installation',
  CLOSETS: 'Closet Installation',
  COUNTER_TOPS: 'Countertop Installation',
  MINI_SPLITS: 'Mini Split Installation',
  GARAGE_DOOR: 'Garage Door Installation',
  DEFAULT_SERVICE: 'Get Expert In-Home Installation'
};

const checkboxText = {
  FENCING: 'Request a free consultation',
  TANKLESS_WATER_HEATER: 'Request a free consultation',
  TANK_WATER_HEATER: 'Request a free consultation',
  GENERATORS: 'Request a free consultation',
  WINDOWS: 'Request a consultation',
  DREAMLINE_SHOWER_DOOR: 'Request a free consultation',
  PLUMBING_REPAIR: 'Request plumbing repair service',
  WATER_HEATER_REPAIR: 'Request water heater repair service',
  CLEANCUT_TUBS: 'Request a free consultation',
  DOORS: 'Request door installation service',
  CLOSETS: 'Request a free consultation',
  COUNTER_TOPS: 'Request a free consultation',
  MINI_SPLITS: 'Request a free consultation',
  GARAGE_DOOR: 'Customize your garage door with our online design tool and get a free quote',
  DEFAULT_SERVICE: 'Request installation service'
};

const buttonText = {
  FENCING: 'Request Free Consultation',
  TANKLESS_WATER_HEATER: 'Request Free Consultation',
  TANK_WATER_HEATER: 'Request Free Consultation',
  GENERATORS: 'Request Free Consultation',
  WINDOWS: 'Request Consultation',
  DREAMLINE_SHOWER_DOOR: 'Request Free Consultation',
  PLUMBING_REPAIR: 'Request Appointment',
  WATER_HEATER_REPAIR: 'Request Appointment',
  CLEANCUT_TUBS: 'Request Free Consultation',
  DOORS: 'Request Appointment',
  CLOSETS: 'Request Free Consultation',
  COUNTER_TOPS: 'Request Free Consultation',
  MINI_SPLITS: 'Request Free Consultation',
  GARAGE_DOOR: 'Get Started',
  DEFAULT_SERVICE: 'Request Appointment'
};

const getDualPathHeading = (category) => {
  const categoryKey = DUAL_PATH_CATEGORIES[category];
  if (headingCategory[categoryKey]) {
    return 'Get Expert ' + headingCategory[categoryKey];
  }
  return headingCategory.DEFAULT_SERVICE;
};

const getDualPathCheckbox = (category) => {
  const categoryKey = DUAL_PATH_CATEGORIES[category];
  if (checkboxText[categoryKey]) {
    return checkboxText[categoryKey];
  }
  return checkboxText.DEFAULT_SERVICE;
};

const getDualPathButtonText = (category) => {
  const categoryKey = DUAL_PATH_CATEGORIES[category];
  if (buttonText[categoryKey]) {
    return buttonText[categoryKey];
  }
  return buttonText.DEFAULT_SERVICE;
};

const getDualPathCategoryModel = (category) => {
  const categoryKey = DUAL_PATH_CATEGORIES[category];
  if (dualPathTooltipCategories[categoryKey]) {
    return dualPathTooltipCategories[categoryKey];
  }
  return dualPathTooltipCategories.DEFAULT_SERVICE;
};

export {
  getDualPathCategoryModel, getDualPathHeading, getDualPathButtonText, getDualPathCheckbox, DUAL_PATH_CATEGORIES
};